import type { PipelineRunRow, StageRunRow, WorkJourneyRow } from '../api';

export function legacyJourney(
  run: PipelineRunRow,
  stageRuns: StageRunRow[]
): WorkJourneyRow {
  const status =
    run.status === 'merged'
      ? 'success'
      : run.status === 'closed'
        ? 'closed'
        : 'running';
  return {
    workJourneyId: run.workJourneyId || run.pipelineRunId,
    organizationId: run.organizationId,
    primaryProjectId: run.projectId,
    projectIds: run.projectId ? [run.projectId] : [],
    title: run.title,
    status: run.status === 'closed' ? 'closed' : 'active',
    correlationKeys: [],
    taskRefs: run.taskRefs,
    responsibilities: [],
    policies: [],
    firstSeenAt: run.openedAt || run.created || new Date().toISOString(),
    lastActivityAt: run.updated || run.openedAt || new Date().toISOString(),
    items: [
      {
        workJourneyItemId: `legacy-pr:${run.pipelineRunId}`,
        workJourneyId: run.pipelineRunId,
        organizationId: run.organizationId,
        projectId: run.projectId,
        kind: 'pull_request',
        provider: run.provider,
        externalRepo: run.externalRepo,
        externalRefType: 'pull_request',
        externalRefId: String(run.externalPrNumber),
        title: run.title,
        status,
        url: run.url,
        author: run.author,
        branch: run.branch,
        headSha: run.headSha,
        startedAt: run.openedAt,
        finishedAt: run.mergedAt || run.closedAt
      },
      ...stageRuns
        .filter((stage) => stage.stageType === 'ci_check')
        .map((stage) => ({
          workJourneyItemId: `legacy-stage:${stage.stageRunId}`,
          workJourneyId: run.pipelineRunId,
          organizationId: run.organizationId,
          projectId: run.projectId,
          kind: 'check' as const,
          provider: stage.provider,
          externalRepo: stage.externalRepo,
          externalRefType: stage.externalRefType,
          externalRefId: stage.externalRefId,
          title: stage.label || 'Verification',
          status:
            stage.status === 'in_progress'
              ? ('running' as const)
              : stage.status,
          url: stage.url,
          startedAt: stage.startedAt,
          finishedAt: stage.finishedAt
        }))
    ],
    expectations: [],
    attention: [],
    dispatchRuns: []
  };
}
